<script setup lang="ts">
import { ref } from 'vue'
import { track } from '@/lib/usageTracker'
import { Alert, Button, Card } from '@/components/ui'
import { BookOpen, RefreshCw } from 'lucide-vue-next'

const syncing = ref(false)
const error = ref('')
const accounts = ref<unknown[]>([])

async function syncAll() {
  track('btn:RefreshLedgerMapping', 'click')
  error.value = ''
  try {
    // TODO: fetch from store DB when store API is available
  } catch (e) {
    error.value = (e as Error)?.message || 'Sync failed'
  } finally {
    syncing.value = false
  }
}

</script>

<template>
  <div class="app-page app-page--narrow">
    <section class="app-page-header">
      <div class="app-page-heading">
        <div class="app-page-eyebrow">
          <BookOpen class="h-4 w-4" />
          <span>Chart of accounts</span>
        </div>
        <h1 class="app-page-title">Ledger mapping workspace</h1>
        <p class="app-page-subtitle">Review and configure how your store accounts map to your accounting provider's chart of accounts.</p>
      </div>
      <div class="app-page-actions">
        <Button variant="secondary" :loading="syncing" @click="syncAll">
          <RefreshCw class="h-4 w-4" />
          {{ syncing ? 'Working…' : 'Refresh mapping' }}
        </Button>
      </div>
    </section>

    <Alert v-if="error" variant="error" title="Ledger sync issue" compact class="page-alert">
      {{ error }}
    </Alert>

    <Card>
      <div class="app-empty-state">
        <div class="app-empty-state-symbol">
          <BookOpen class="h-5 w-5" />
        </div>
        <div class="app-empty-state-title">Ledger mapping controls being prepared</div>
        <div class="app-empty-state-copy">
          {{ accounts.length }} accounts are currently loaded. Detailed mapping controls will appear once the store database feed is connected.
        </div>
      </div>
    </Card>
  </div>
</template>

<style scoped>
.page-alert { margin-bottom: 1rem; }
</style>
